import { ItemList } from '../orm'

class BillingAddressList extends ItemList {
    getEntityKey() {
        return "customer/billing_address"
    }
    
}

export const billingAddressList = new BillingAddressList("billing_address_default")